// extracted by mini-css-extract-plugin
export default {"title":"vmqVxt","inner-Wrapper":"JC_Wwt","innerWrapper":"JC_Wwt","full-width-button":"X3HMjQ","fullWidthButton":"X3HMjQ"};